export const PROJECT_URLS = {
  MI_PERFIL: "/area-cliente/mi-perfil",
  MIS_CONSENTIMIENTOS: "/area-cliente/mi-perfil/mis-consentimientos",
  MIS_CONSENTIMIENTOS_PUBLICIDAD: "/area-cliente/mi-perfil/mis-consentimientos/preferencias-publicidad",
  MIS_CONSENTIMIENTOS_BASICOS: "/area-cliente/mi-perfil/mis-consentimientos/basicos",
  MIS_CONSENTIMIENTOS_OPEN_GATEWAY: "/area-cliente/mi-perfil/mis-consentimientos/open-gateway",
  DETALLE_CONSENTIMIENTO: "/area-cliente/mi-perfil/mis-consentimientos/detalle",
  MEJORAR_MI_EXPERIENCIA: "/area-cliente/mi-perfil/mis-consentimientos/mejorar-mi-experiencia",
  MI_CUENTA: "/area-cliente/mi-cuenta",
  MOVISTAR_POR_TI: "/area-cliente/movistar-por-ti",
  CAMBIO_CONTRASENA: "/area-cliente/mi-perfil/cambio-contrasena",
  MIS_PRODUCTOS: "/area-cliente/mis-productos",
  FACTURAS: "/area-cliente/facturas",
  LISTADO_FACTURAS: "/area-cliente/facturas/listado-facturas",
  DETALLE_FACTURAS: "/area-cliente/facturas/detalle-factura",
  DIRECCION_FACTURACION: "/area-cliente/facturas/direccion-de-facturacion",
  CAMBIO_DIRECCION_FACTURACION: "/area-cliente/facturas/direccion-de-facturacion/cambiar-direccion",
  ALIAS_DETALLE_FACTURAS_PREPAGO:
    "/area-cliente/facturas/detalle-factura-prepago",
  INTERNET: "/area-cliente/mis-productos/internet",
  SEGUNDA_FIBRA: "/area-cliente/mis-productos/segunda-fibra",
  FIBRA_ADICIONAL: "/area-cliente/mis-productos/fibra-adicional/",
  FTTR: "/area-cliente/mis-productos/fttr",
  LINEA_MOVIL: "/area-cliente/mis-productos/linea-movil",
  DISPOSITIVOS: "/area-cliente/mis-productos/dispositivos",
  TV: "/area-cliente/mis-productos/tv",
  CONSUMOS: "/area-cliente/mis-productos/consumos",
  CONSUMOS_DETALLE: "/area-cliente/mis-productos/consumos/detalle",
  GASTO_EXTRA: "/area-cliente/mis-productos/consumos/gasto-extra",
  GESTIONES: "/area-cliente/gestiones",
  GESTIONES_INTERNET: "/area-cliente/gestiones/internet",
  GESTIONES_LINEA_MOVIL: "/area-cliente/gestiones/linea-movil",
  GESTIONES_LINEA_MOVIL_BLOQUEOS:
    "/area-cliente/gestiones/linea-movil/bloqueos",
  GESTIONES_LINEA_MOVIL_BLOQUEOS_DETALLE:
    "/area-cliente/gestiones/linea-movil/bloqueos/detalle",
  GESTIONES_LINEA_FIJA: "/area-cliente/gestiones/linea-fija",
  GESTIONES_LINEA_FIJA_BLOQUEOS: "/area-cliente/gestiones/linea-fija/bloqueos",
  GESTIONES_LINEA_FIJA_BLOQUEOS_DETALLE:
    "/area-cliente/gestiones/linea-fija/bloqueos/detalle",
  GESTIONES_LINEA_FIJA_MAS_GESTIONES_DETALLE:
    "/area-cliente/gestiones/linea-fija/mas-gestiones/detalle",
  GESTIONES_LINEA_FIJA_DESVIO_DETALLE:
    "/area-cliente/gestiones/linea-fija/desvio/detalle",
  GESTIONES_FACTURAS:
    "/area-cliente/gestiones/facturas",
  GESTIONES_RECARGAR_LINEA: "/area-cliente/gestiones/facturas/recargar-linea",
  GESTIONES_DATOS_PERSONALES:
    "/area-cliente/gestiones/datos-personales",

  GESTIONES_TV: "/area-cliente/gestiones/tv",
  TU_PACK: "/area-cliente/mis-productos/mi-pack",
  ALARMAS: "/area-cliente/mis-productos/alarmas",
  SALUD: "/area-cliente/mis-productos/salud",
  GAME_PASS: "/area-cliente/mis-productos/game-pass",
  SMART_WIFI: "/area-cliente/mis-productos/smart-wifi",
  SEGURO_MOVIL: "/area-cliente/mis-productos/seguro-movil",
  CAR: "/area-cliente/mis-productos/movistar-car",
  OTP: "/area-cliente/otp",
  LISTADO_PEDIDOS: "/area-cliente/mi-perfil/seguimiento-de-pedidos/",
  DETALLE_PEDIDOS: "/area-cliente/mi-perfil/seguimiento-de-pedidos/detalle",
  GESTIONES_LINEA_MOVIL_DETALLE: "/area-cliente/gestiones/linea-movil/detalle",
  SOPORTE: "/area-cliente/soporte",
  AUTODIAGNOSTICO: "/area-cliente/soporte/autodiagnostico",
  DETALLE_AVERIA: "/area-cliente/soporte/averia",
  GESTIONES_LINEA_MOVIL_IMEI_PUK:
    "/area-cliente/gestiones/linea-movil/imei-puk",
  ACTIVACION_PERPLEXITY: "/area-cliente/mis-productos/activacion-perplexity",
  ONBOARDING_HOME: "/area-cliente/mi-perfil/verificacion-avanzada/inicio",
  VERIFY_CONTACT_MEANS: "/area-cliente/mi-perfil/medios-contacto/nuevo-medio-contacto",
  CHANGE_EMAIL: "/area-cliente/mi-perfil/modificar-email",
  CHANGE_PHONE: "/area-cliente/mi-perfil/modificar-telefono-contacto",
  ADITIONALS_LINES: "/area-cliente/mis-productos/lineas-adicionales",
  PAGO_DEUDA: "/area-cliente/pago-deuda",
  FUNCIONALITIES: "/area-cliente/mis-productos/tv/funcionalidades/",
  RECHARGE_PREPAID: "/area-cliente/gestiones/linea-movil/recargar-prepago",
  ANTICIPATE_PREPAID: "/area-cliente/gestiones/linea-movil/anticipar-saldo",
  CLAIMS: "/area-cliente/facturas/reclamaciones",
  CERBERUS: "/area-cliente/mi-perfil/informe-bloqueos",
  CERBERUS_REPORT: "/area-cliente/mi-perfil/informe-bloqueos/informe-amenazas",
  FAST_PASS: "/area-cliente/fast-pass",
  ECO_BILL: "/area-cliente/facturas/factura-sin-papel/",
  CHANGE_PHONE: "/area-cliente/mi-perfil/modificar-numero-telefono",
  HOME_ESIM: "/area-cliente/gestiones/linea-movil/e-sim/inicio-proceso"
};

export const PROVIDER_ACTIVATION_URL =
  "/area-cliente/mis-productos/tv/activacion/";

export const DISNEY_LOGIN_URL = "https://www.disneyplus.com/login";
export const DISNEY_ACTIVATION_DPROVIDER_ACTIVATION_URL =
  "https://www.movistar.es/cliente/areaprivada/#/disney?pid=PA-telco-mis-productos-television-activar-disney";


export const SSO_PDB_URL_PROD = "https://www.movistar.es/auth/sso/pdb"
export const SSO_PDB_URL_CERT = "https://www.movistar.es.cert/auth/sso/pdb"
